import { getTokenFCM } from './firebase'

const initNotifs = () => {
    getTokenFCM()
}

export { initNotifs }